export const currentCourseState = (currentCourse, state) => {
  const { byCourse } = state;
  return byCourse[currentCourse.course_id] || {};
};
